<template>
  <b-card>
    <b-row class="justify-content-between">
      <b-col class="pr-md-32 pr-md-120">
        <h4>Tooltips and popovers</h4>

        <p class="hp-p1-body">
          Tooltips and popovers can be placed within modals as needed. When
          modals are closed, any tooltips and popovers within are also
          automatically dismissed. Tooltips and popovers are automatically
          appended to the modal element (to ensure correct z-indexing), although
          you can override where they are appended by specifying a container ID
          (refer to tooltip and popover docs for details).
        </p>
      </b-col>

      <b-col class="hp-flex-none w-auto">
        <b-button
          @click="codeClick()"
          variant="text"
          class="btn-icon-only show-code-btn"
        >
          <i
            class="ri-code-s-slash-line hp-text-color-black-80 hp-text-color-dark-30 lh-1"
            style="font-size: 16px"
          ></i>
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <div class="col-12 mt-16">
        <b-button variant="primary" v-b-modal.modalPopover>Show Modal</b-button>

        <b-modal id="modalPopover" ok-only header-class="align-items-center">
          <template #modal-header="{ close }">
            <h5 class="mb-0">Modal with Popover</h5>

            <b-button
              variant="text"
              @click="close()"
              class="btn-close bg-transparent p-0 d-flex align-items-center justify-content-center"
              style="min-height: 24px"
            >
              <i
                class="ri-close-line hp-text-color-dark-0 lh-1"
                style="font-size: 24px"
              ></i>
            </b-button>
          </template>

          <p class="hp-p1-body">
            This
            <b-button
              variant="primary"
              v-b-popover="'Popover inside a modal!'"
              title="Popover"
            >
              Button
            </b-button>
            triggers a popover on click.
          </p>

          <p class="hp-p1-body">
            This
            <a href="#" v-b-tooltip title="Tooltip in a modal!">Link</a> will
            show a tooltip on hover.
          </p>
        </b-modal>
      </div>

      <div
        v-if="codeActive"
        class="col-12 mt-24 hljs-container"
        :class="{ active: codeActiveClass }"
      >
        <pre v-highlightjs>
          <code class="hljs html">
            {{ codeText }}
          </code>
        </pre>
      </div>
    </b-row>
  </b-card>
</template>

<script>
import { BRow, BCol, BCard, BButton, BModal } from "bootstrap-vue";
import code from "./code";

export default {
  data() {
    return {
      codeText: code.tooltipsPopovers,
      codeActive: false,
      codeActiveClass: false,
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BModal,
  },
  methods: {
    codeClick() {
      this.codeActive = !this.codeActive;

      setTimeout(() => {
        this.codeActiveClass = !this.codeActiveClass;
      }, 100);
    },
  },
};
</script>
